import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import flowConfig from "./config/flowConfig.json";

const resources = {
  en: {
    homeModule: require("./locales/en/homeModule.json"),
    preparationPage: require("./locales/en/preparationPage.json"),
    scanGuidancePage: require("./locales/en/scanGuidancePage.json"),
    scanModule: require("./locales/en/scanModule.json"),
    questionsModule: require("./locales/en/questionsModule.json"),
    aiResults: require("./locales/en/aiResults.json"),
    productModule: require("./locales/en/productModule.json"),
    customAiInfo: require("./locales/en/customAiInfo.json"),
    customHomeInfo: require("./locales/en/customHomeInfo.json"),
    customQuestions: require("./locales/en/customQuestions.json"),
    errorPage: require("./locales/en/errorPage.json"),
    geoBlockPage: require("./locales/en/geoBlockPage.json"),
  },
  de: {
    homeModule: require("./locales/de/homeModule.json"),
    preparationPage: require("./locales/de/preparationPage.json"),
    scanGuidancePage: require("./locales/de/scanGuidancePage.json"),
    scanModule: require("./locales/de/scanModule.json"),
    questionsModule: require("./locales/de/questionsModule.json"),
    aiResults: require("./locales/de/aiResults.json"),
    productModule: require("./locales/de/productModule.json"),
    customAiInfo: require("./locales/de/customAiInfo.json"),
    customHomeInfo: require("./locales/de/customHomeInfo.json"),
    customQuestions: require("./locales/de/customQuestions.json"),
    errorPage: require("./locales/de/errorPage.json"),
    geoBlockPage: require("./locales/de/geoBlockPage.json"),
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources,
    lng: flowConfig.defaultLanguage,
    supportedLngs: flowConfig.availableLanguages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
